import React from 'react'
import PropTypes from 'prop-types'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import StyleSheet from 'styles'
import { ConfirmationDialog } from './ConfirmationDialog'

const styles = StyleSheet({
  textField: {
    width: '100%'
  }
})

export class InputDialog extends ConfirmationDialog {
  static propTypes = {
    valueRequired: PropTypes.bool,
    explanation: PropTypes.string,
    label: PropTypes.string,
    initialValue: PropTypes.any,
  }

  static defaultProps = {
    children: <TextField margin="normal" className={styles.textField}/>,
    valueRequired: false,
    explanation: '',
    canCancel: true,
    confirmLabel: 'OK',
    cancelLabel: 'CANCEL',
    theme: 'light'
  }

  componentDidUpdate = (prevProps) => {
    if (!prevProps.open && this.props.open) {
      this.setState({value: this.props.initialValue})
    }
  }

  handleValueChanged = (event) => {
    this.setValue(event.target.value)
  }

  canConfirm() {
    if(this.props.valueRequired) {
      return this.value && (this.value.trim().length !== 0)
    }
    return true
  }


  renderBody() {
    return (
      <div>
        <Typography variant='subtitle1'>{this.props.explanation}</Typography>
        {React.cloneElement(React.Children.only(this.props.children), {
          value: this.state.value,
          label: this.props.label,
          required: this.props.valueRequired,
          onChange: this.handleValueChanged
        })}
      </div>
    )
  }
}

export default InputDialog
